import axios from "./axios";

/**
 * 服務准入-校長准照續期
 * @param {*} serviceType 
 * @param {*} identType 
 * @param {*} identNo 
 * @param {*} licType 
 * @param {*} licNo 
 * @returns 
 */
const check = (serviceType, identType, identNo, licNo, licType = "0") => {
    return axios.post(`/protected/api/v1/headmaster/check/${serviceType}?identType=${identType}&identNo=${identNo}${licNo ? `&licType=${licType}&licNo=${licNo}`:''}`).then(res => res.data)
}

/**
 * 根据申请编号获取详情-校長准照續期
 * @param {*} applicationNo 
 * @returns 
 */
const getDetail = (applicationNo) => {
    return axios.get(`/protected/api/v1/headmaster/detail/${applicationNo}`).then(res => res.data)
}

/**
 * 查詢校長准照續期歷史記錄
 * @param {*} serviceType 
 * @param {*} coachId 
 */
const history = (serviceType, coachId) => {
    return axios.post(`/protected/api/v1/headmaster/history/${serviceType}?coachId=${coachId}`).then(res => res.data)
}

/**
 * 提交教校長續期申請
 * @param {*} email 
 * @param {*} sendSms 
 * @param {*} serviceType 
 * @param {*} identType 
 * @param {*} identNo 
 * @param {*} licNo 
 * @param {*} licType 
 * @returns 
 */
 const submit = (email, sendSms, serviceType, identType, identNo, licNo, licType = "0") => {
    return axios.post(`/protected/api/v1/headmaster/submit/${serviceType}?identType=${identType}&identNo=${identNo}${licNo ? `&licType=${licType}&licNo=${licNo}`:''}${email?`&email=${email}`:''}${sendSms?`&sendSms=${sendSms}`:''}`).then(res => res.data)
}

export default {
    check,
    getDetail,
    history,
    submit
}